import { render, staticRenderFns } from "./SignModel.vue?vue&type=template&id=1926643f&scoped=true&"
import script from "./SignModel.vue?vue&type=script&lang=js&"
export * from "./SignModel.vue?vue&type=script&lang=js&"
import style0 from "./SignModel.vue?vue&type=style&index=0&id=1926643f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926643f",
  null
  
)

export default component.exports